import { render, staticRenderFns } from "./VistaPerfil.vue?vue&type=template&id=69b63e90&scoped=true"
import script from "./VistaPerfil.vue?vue&type=script&lang=js"
export * from "./VistaPerfil.vue?vue&type=script&lang=js"
import style0 from "./VistaPerfil.vue?vue&type=style&index=0&id=69b63e90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b63e90",
  null
  
)

export default component.exports